// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heartbit {
  position: relative;
  display: inline-block;
  width: 8px;
  height: 8px;
}
.heartbit::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: inherit;
  border-radius: 50%;
  animation: ripple 1s ease-out infinite;
}

@keyframes ripple {
  from {
    opacity: 1;
    transform: scale(0);
  }
  to {
    opacity: 0;
    transform: scale(4);
  }
}
.loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.w-100 .dropdown.radio-select,
.w-100 .dropdown-trigger.arrow.top,
.w-100 .dropdown-trigger.arrow.bottom {
  width: 100%;
}

.expanded-text {
  color: #1570ef;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sCAAA;AACJ;;AAGA;EACE;IACE,UAAA;IACA,mBAAA;EAAF;EAGA;IACE,UAAA;IACA,mBAAA;EADF;AACF;AAIA;EACE,oCAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAFF;;AAKA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;;;EAGE,WAAA;AAHF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AALF","sourcesContent":[".heartbit {\n  position: relative;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: inherit;\n    border-radius: 50%;\n    animation: ripple 1s ease-out infinite;\n  }\n}\n\n@keyframes ripple {\n  from {\n    opacity: 1;\n    transform: scale(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(4);\n  }\n}\n\n.loader {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.w-100 .dropdown.radio-select,\n.w-100 .dropdown-trigger.arrow.top,\n.w-100 .dropdown-trigger.arrow.bottom {\n  width: 100%;\n}\n\n// expanded text component styles\n\n.expanded-text {\n  color: #1570ef;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
